import { Button } from '../buttons/Button'

type ProgressStepsProps = {
  steps: string[]
  currentStep: number
  ariaLabel: string
  className?: string
  onStepChange?: (step: number) => void
  isStepDisabled?: (step: number) => boolean
  skippedSteps?: number[]
  skippedLabel?: string
}

const ProgressSteps = ({
  steps,
  currentStep,
  ariaLabel,
  className = '',
  onStepChange,
  isStepDisabled,
  skippedSteps = [],
  skippedLabel,
}: ProgressStepsProps) => (
  <nav
    className={`progress-steps-wrap ${className}`.trim()}
    aria-label={ariaLabel}
  >
    <div className="progress-steps d-flex gap-1">
      {steps.map((step, index) => {
        const stepNumber = index + 1
        const isActive = stepNumber === currentStep
        const isCompleted = stepNumber < currentStep
        const isSkipped = skippedSteps.includes(stepNumber)
        const disabled = isStepDisabled?.(stepNumber) ?? false
        const state = isActive
          ? 'active'
          : isSkipped
            ? 'skipped'
            : isCompleted
              ? 'completed'
              : 'upcoming'
        const label =
          isSkipped && skippedLabel ? `${step} · ${skippedLabel}` : step

        return (
          <div
            className={`progress-step flex-fill progress-step-${state}${
              disabled ? ' progress-step-disabled' : ''
            }`}
            key={step}
          >
            <span className="progress-step-bar" aria-hidden="true" />
            <Button
              className="progress-step-trigger"
              variant="ghost"
              size="sm"
              icon={<span className="progress-step-number">{stepNumber}</span>}
              label={label}
              labelClassName="progress-step-label"
              aria-current={isActive ? 'step' : undefined}
              onClick={() => onStepChange?.(stepNumber)}
              disabled={!onStepChange || disabled}
            />
          </div>
        )
      })}
    </div>
  </nav>
)

export default ProgressSteps
